import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { SplideSlide } from '@splidejs/react-splide';
import { fetchSimilar } from '@/redux/store/actions/product';
import { similarHousesCarouselSetting } from '@/components/houses/_constants';
import Box from '@/components/UI/box/Box';
import Carousel from '@/components/reusable/carousel/Carousel';
import SimilarProductsCard from './similarProductsCard/SimilarProductsCard';
import SimilarProductsContainerSkeleton from '../similarProductsContainerSkeleton/SimilarProductsContainerSkeleton';
import styles from './SimilarProductsContainer.module.scss';
const SimilarProductsContainer = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const {
    similarHouses
  } = useSelector(state => ({
    similarHouses: state.similarHouses
  }));
  useEffect(() => {
    if (process.env.OFFLINE_MODE === 'true') return;
    dispatch(fetchSimilar(router.query.id as string | string[]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.id]);
  if (process.env.OFFLINE_MODE === 'true') return null;
  if (!similarHouses?.list?.length || similarHouses?.loading) {
    return <SimilarProductsContainerSkeleton />;
  }
  return <Box className={styles['similar-products-container']} data-sentry-element="Box" data-sentry-component="SimilarProductsContainer" data-sentry-source-file="SimilarProductsCountainer.tsx">
      <Carousel opts={similarHousesCarouselSetting} data-sentry-element="Carousel" data-sentry-source-file="SimilarProductsCountainer.tsx">
        {similarHouses?.list?.map((item, index) => <SplideSlide key={item.id}>
            <SimilarProductsCard data={item} index={index} />
          </SplideSlide>)}
      </Carousel>
    </Box>;
};
export default SimilarProductsContainer;